import React from "react"
import Switch from '../../Switch/Switch'

class IncidentalDepositBuilderAuthorizationMaintenance extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return(
     <div>
       <h5 className="panel-heading-text" style={{ borderBottom: '1px solid #DFDFDF', paddingBottom: 20, paddingTop: 10 }}>{I18n.t('authorization_maintenance')}</h5>
       <div className="row">
         {this.renderMaintainAuthorizationSwitch()}
       </div>
       <br />

       {
         this.props.maintain_authorization
         ?
          <div className="row">
            {this.renderAuthorizationMaintenanceSelect()}
          </div>
         :
        null
       }
     </div>
   )
  }

  renderMaintainAuthorizationSwitch() {
    return(
      <div className="col-md-12">
        <div className="form-group">
          <label>{I18n.t('maintain_authorization')}</label>
          <Switch 
            onText="yes"
            switchId="maintain-authorization-switch"
            offText="no"
            value={this.props.maintain_authorization} 
            onChange={this.props.onChangeMaintainAuthorization} 
          />
        </div>
      </div>
    )
  }

  renderAuthorizationMaintenanceSelect() {
      return(
        <div className="col-md-12">
          <div className="form-group">
            <label>{I18n.t('reauthorize')}</label>
            <select  className="form-control" defaultValue={this.props.incidental_deposit.reauthorize ? this.props.incidental_deposit.reauthorize : "nightly"} onChange={this.props.onChangeReauthorization} >
              <option value="nightly">{I18n.t('nightly')}</option>
              <option value="authorization_expiration">{I18n.t('authorization_expiration')}</option>
            </select>
          </div>
        </div>
      )
  }

}

export default IncidentalDepositBuilderAuthorizationMaintenance